import { useContext, useEffect, useRef } from 'react';
import AppliedFiltersContext from '~/context/srp/AppliedFiltersContext';
import { useFinanceInfo } from '~/context/srp/FinanceContext';

/**
 * Ensure that finance filters are within the min/max range.
 *
 * If Search API responds with a minimum down payment that is higher than the
 * current applied down payment or maximum monthly payment that is lower than
 * the current applied monthly payment, update the applied filters to be within
 * the min/max range.
 */
export default function useEnsureFinanceFiltersAreInRange() {
  const { appliedFilters, updateRangeFilter } = useContext(
    AppliedFiltersContext
  );
  const { maxMonthlyPayment, minDownPayment } = useFinanceInfo();

  const downPaymentRef = useRef(appliedFilters.finance?.downPayment);
  const monthlyPaymentRef = useRef(appliedFilters.finance?.monthlyPayment);

  useEffect(() => {
    downPaymentRef.current = appliedFilters.finance?.downPayment;
    monthlyPaymentRef.current = appliedFilters.finance?.monthlyPayment;
  }, [
    appliedFilters.finance?.downPayment,
    appliedFilters.finance?.monthlyPayment
  ]);

  useEffect(() => {
    const downPayment =
      downPaymentRef.current == null
        ? undefined
        : Math.max(downPaymentRef.current, minDownPayment);
    const monthlyPayment =
      monthlyPaymentRef.current == null
        ? undefined
        : Math.min(monthlyPaymentRef.current, maxMonthlyPayment);

    if (downPayment == null && monthlyPayment == null) return;

    updateRangeFilter({
      filterKey: 'finance',
      value: { downPayment, monthlyPayment }
    });
  }, [maxMonthlyPayment, minDownPayment, updateRangeFilter]);
}
